import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import legacyEn from "#shared/locales/en.json";
import { formatCount } from "#shared/lib/format-number.ts";

export const I18N_NAMESPACES = {
  login: "login",
  app: "app",
  adminConsole: "adminConsole",
  docs: "docs",
  legacy: "legacy",
} as const;

function resolveNamespace(namespace: keyof typeof I18N_NAMESPACES): string {
  return I18N_NAMESPACES[namespace];
}

export function setI18nNamespace(
  namespace: keyof typeof I18N_NAMESPACES,
): void {
  i18n.setDefaultNamespace(resolveNamespace(namespace));
}

export function registerI18nNamespace(
  namespace: keyof typeof I18N_NAMESPACES,
  resources: Record<string, unknown>,
): void {
  i18n.addResourceBundle(
    "en",
    resolveNamespace(namespace),
    resources,
    true,
    true,
  );
}

void i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  ns: [I18N_NAMESPACES.legacy],
  defaultNS: I18N_NAMESPACES.legacy,
  fallbackNS: I18N_NAMESPACES.legacy,
  resources: {
    en: {
      [I18N_NAMESPACES.legacy]: legacyEn,
    },
  },
  interpolation: { escapeValue: false },
});

i18n.services.formatter?.add("count", (value) => formatCount(Number(value)));

export default i18n;
